import { Component, OnDestroy, OnInit } from '@angular/core';
import { InboxControllerService, InboxState, MizenAngularLibService, NotificationDTO } from "mizen-angular-lib";
import { map, retry, share, switchMap } from "rxjs/operators";
import { Subscription, timer } from "rxjs";
import { CapAlertService } from "../exceptions/cap-alert.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'cap-mizen-inbox',
  templateUrl: './mizen-inbox.component.html',
  styleUrls: ['./mizen-inbox.component.scss']
})
export class MizenInboxComponent implements OnInit, OnDestroy {

  public inboxState: InboxState;
  public inboxPath: string;
  public noAttachments: boolean = false;

  private polling$: Subscription;
  private lastPollingDate: Date;

  constructor(
    private inboxControllerService: InboxControllerService,
    private mizenAngularLibService: MizenAngularLibService,
    private capAlertService: CapAlertService,
    private translate: TranslateService
  ) {
    this.polling$ = timer(1, 5000).pipe(
      switchMap(() => {
        return this.inboxControllerService.getInboxState().pipe(
          map(inboxState => this.checkForNewNotifications(inboxState))
        );
      }),
      retry(1),
      share()
    ).subscribe();
    this.inboxPath = this.mizenAngularLibService.getInboxURL();
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.polling$?.unsubscribe();
  }

  getNotificationURL(notification: NotificationDTO): string {
    return this.mizenAngularLibService.getNotificationURL(notification);
  }



  private checkForNewNotifications(inboxState: InboxState): void {
    if (this.lastPollingDate && inboxState.unreadNotifications.some(unreadNotification => this.lastPollingDate < new Date(unreadNotification.createDateTime))) {
      this.capAlertService.info(this.translate.instant('inbox.new-message'));
    }
    this.inboxState = inboxState;
    this.noAttachments = this.inboxState.unreadNotifications.every(unreadNotification => unreadNotification.attachmentList.length <= 0);
    this.lastPollingDate = new Date();
  }
}
